<template>
  <div>
    <b-container>
      <b-row align-v="center">
        <b-col sm="2">
          <h1 class="mb-0">Bookings</h1>
        </b-col>
        <b-col sm="10" class="text-sm-right">
          <b-button variant="primary mr-1" @click="initQuickAdd">
            <i class="fa fa-plus pr-1" /> Walk-in
          </b-button>
          <router-link
            class="btn btn-primary mr-1"
            :to="{ name: 'bookings/add' }"
          >
            <i class="fa fa-plus pr-1" /> Custom
          </router-link>
          <b-button variant="warning" @click="initAddBreak">
            <i class="fa fa-plus pr-1" /> Break
          </b-button>
        </b-col>
      </b-row>
      <b-tabs
        class="mt-3"
        content-class="mt-3"
        :value="tabIndex"
        @input="onTabInput"
      >
        <b-tab title="ALL" @click="onAllTab"></b-tab>
        <b-tab
          v-for="resource in resources"
          :key="resource._id"
          :title="resource.name"
          @click="onResourceTab(resource)"
        >
        </b-tab>
      </b-tabs>
      <bookings-calendar
        :resource="resource"
        @booking-click="onBookingClick"
        @timeslot-click="onTimeslotClick"
      ></bookings-calendar>
    </b-container>
    <b-modal id="quick-add-modal" centered title="Schedule Booking - Today">
      <b-form id="quick-add-form" @submit.stop.prevent="saveQuickAddEvent">
        <b-form-group label="Barber">
          <b-button
            v-for="resource in resourceOptions"
            :key="resource._id"
            class="mr-1 mb-1"
            :variant="
              resource === quickAddForm.resource ? 'info' : 'outline-info'
            "
            @click="
              quickAddForm.resource = resource;
              quickAddForm.service = null;
              quickAddForm.package = null;
            "
          >
            {{ resource.name }}
          </b-button>
        </b-form-group>
        <b-form-group v-show="quickAddForm.resource" label="Service">
          <b-button
            v-for="service in serviceOptions"
            :key="service._id"
            class="mr-1 mb-1"
            :variant="
              service === quickAddForm.service ? 'info' : 'outline-info'
            "
            @click="
              quickAddForm.service = service;
              quickAddForm.package = null;
            "
          >
            {{ service.name }}
          </b-button>
        </b-form-group>
        <b-form-group v-show="quickAddForm.service" label="Package">
          <b-button
            v-for="_package in packageOptions"
            :key="_package._id"
            class="mr-1 mb-1"
            :variant="
              _package === quickAddForm.package ? 'info' : 'outline-info'
            "
            @click="
              quickAddForm.package = _package;
              quickAddFormSelectedTime = null;
              fetchAvailableTimes({
                resourceId: quickAddForm.resource._id,
                serviceId: quickAddForm.service._id
              });
            "
          >
            {{ _package.name }}
            €{{ quickAddForm.service.pricesForPackages[_package._id] }}
          </b-button>
        </b-form-group>
        <b-form-group v-show="quickAddForm.package" label="Time">
          <div v-show="isLoadingAvailableTimes" class="text-center">
            <b-spinner label="Loading available booking times"></b-spinner>
          </div>
          <b-alert
            variant="warning"
            :show="!isLoadingAvailableTimes && !hasAvailableBookingTimes"
          >
            No slots available.
          </b-alert>
          <b-button
            v-for="option in availableBookingTimeOptions"
            :key="option.value"
            class="mr-1 mb-1"
            :variant="
              option.value === quickAddFormSelectedTime
                ? 'info'
                : 'outline-info'
            "
            @click="quickAddFormSelectedTime = option.value"
          >
            {{ option.text }}
          </b-button>
        </b-form-group>
        <b-form-group v-show="quickAddFormSelectedTime" label="Customer">
          <b-form-input
            v-model="quickAddForm.customer.name"
            placeholder="Enter name"
            autofocus
          ></b-form-input>
          <b-form-input
            class="mt-2"
            v-model="quickAddForm.customer.phoneNumber"
            type="tel"
            placeholder="Enter phone number"
          ></b-form-input>
          <b-form-input
            class="mt-2"
            v-model="quickAddForm.customer.emailAddress"
            type="email"
            placeholder="Enter email"
          ></b-form-input>
        </b-form-group>
      </b-form>
      <div slot="modal-footer">
        <b-button
          variant="outline-secondary"
          class="mr-1"
          @click="hideQuickAddModal"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          type="submit"
          form="quick-add-form"
          :disabled="!isQuickAddFormValid"
        >
          <b-spinner
            v-if="isSavingQuickAdd"
            variant="light"
            style="height: 20px; width: 20px;"
            label="Saving event"
          ></b-spinner>
          <div v-else>
            Save
          </div>
        </b-button>
      </div>
    </b-modal>
    <b-modal id="break-modal" centered title="Schedule Break - Today">
      <b-form id="break-form" @submit.stop.prevent="saveBreakEvent">
        <b-form-group label="Barber">
          <b-button
            v-for="resource in resourceOptions"
            :key="resource._id"
            class="mr-1 mb-1"
            :variant="
              resource._id === breakForm.resourceId ? 'info' : 'outline-info'
            "
            @click="
              breakForm.resourceId = resource._id;
              fetchAvailableTimes(resource._id);
            "
          >
            {{ resource.name }}
          </b-button>
        </b-form-group>
        <b-form-group label="Duration">
          <b-button
            v-for="option in breakFormDurationOptions"
            :key="option.value"
            class="mr-1 mb-1"
            :variant="
              option.value === breakFormSelectedDuration
                ? 'info'
                : 'outline-info'
            "
            @click="breakFormSelectedDuration = option.value"
          >
            {{ option.text }}
          </b-button>
        </b-form-group>
        <b-form-group label="Time">
          <div v-show="isLoadingAvailableTimes" class="text-center">
            <b-spinner label="Loading available break times"></b-spinner>
          </div>
          <b-alert
            variant="warning"
            :show="!isLoadingAvailableTimes && !hasAvailableBookingTimes"
          >
            No slots available.
          </b-alert>
          <b-button
            v-for="option in availableBookingTimeOptions"
            :key="option.value"
            class="mr-1 mb-1"
            :variant="
              option.value === breakFormSelectedTime ? 'info' : 'outline-info'
            "
            @click="breakFormSelectedTime = option.value"
          >
            {{ option.text }}
          </b-button>
        </b-form-group>
      </b-form>
      <div slot="modal-footer">
        <b-button
          variant="outline-secondary"
          class="mr-1"
          @click="hideBreakModal"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          type="submit"
          form="break-form"
          :disabled="!isBreakFormValid"
        >
          <b-spinner
            v-if="isSavingBreak"
            variant="light"
            style="height: 20px; width: 20px;"
            label="Saving event"
          ></b-spinner>
          <div v-else>
            Save
          </div>
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import _ from 'lodash';

import BookingsCalendar from './BookingsCalendar';
import { DEFAULT_BREAK_EVENT } from '@/store/modules/roster';
import { DEFAULT_BOOKING } from '@/store/modules/bookings';

export default {
  components: {
    BookingsCalendar
  },
  data() {
    return {
      tabIndex: 0,
      resource: null,
      breakFormDurationOptions: [
        {
          value: 30,
          text: '30m'
        }
      ],
      breakForm: { ...DEFAULT_BREAK_EVENT },
      breakFormSelectedTime: null,
      breakFormSelectedDuration: 30,
      isLoadingAvailableTimes: false,
      isSavingBreak: false,
      quickAddForm: _.cloneDeep(DEFAULT_BOOKING),
      quickAddFormSelectedTime: null,
      isSavingQuickAdd: false
    };
  },
  methods: {
    ...mapActions({
      fetchResources: 'resources/fetchResources',
      fetchServices: 'services/fetchServices',
      fetchPackages: 'packages/fetchPackages',
      createEvent: 'roster/createEvent',
      createBooking: 'bookings/createBooking',
      fetchAvailableBookingTimes: 'bookings/fetchAvailableBookingTimes'
    }),
    onTabInput(tabIndex) {
      this.tabIndex = tabIndex;
    },
    onAllTab() {
      this.setResource(null);
    },
    onResourceTab({ _id }) {
      this.setResource(_id);
    },
    setResource(resource) {
      this.resource = resource;
    },
    onBookingClick(booking) {
      this.$router.push({ name: 'bookings/edit', params: { id: booking._id } });
    },
    onTimeslotClick(timeslot) {
      if (this.timeslotBeforeCurrentTime(timeslot)) return;

      let { start, end, allDay } = timeslot;

      if (allDay) {
        const now = moment();

        start = moment(start).set({
          hour: now.get('hour'),
          minute: now.get('minute')
        });

        const remainder = 30 - (start.minute() % 30);

        start = start.add(remainder, 'minutes').format();

        end = moment(start)
          .add(30, 'minutes')
          .format();
      }

      this.$router.push({
        name: 'bookings/add',
        params: {
          start: start,
          end: end
        }
      });
    },
    timeslotBeforeCurrentTime({ start }) {
      return start < new Date();
    },
    initQuickAdd() {
      this.setQuickAddFormDefaults();
      this.showQuickAddModal();
    },
    setQuickAddFormDefaults() {
      let preselectedResource = null;

      if (this.resource) {
        preselectedResource = this.resources.find(
          resource => resource._id === this.resource
        );
      }

      this.quickAddForm = {
        ..._.cloneDeep(DEFAULT_BOOKING),
        resource: preselectedResource
      };
    },
    showQuickAddModal() {
      this.$bvModal.show('quick-add-modal');
    },
    hideQuickAddModal() {
      this.$bvModal.hide('quick-add-modal');
    },
    initAddBreak() {
      this.setBreakFormDefaults();
      this.showBreakModal();
      const { resourceId } = this.breakForm;
      this.fetchAvailableTimes({ resourceId });
      this.breakFormSelectedTime = this.firstAvailableBookingTime;
    },
    setBreakFormDefaults() {
      const now = moment();
      const resourceId = this.resource || this.firstResourceOption._id;
      this.breakForm = {
        ...DEFAULT_BREAK_EVENT,
        start: now,
        end: now,
        resourceId
      };
    },
    showBreakModal() {
      this.$bvModal.show('break-modal');
    },
    hideBreakModal() {
      this.$bvModal.hide('break-modal');
    },
    async fetchAvailableTimes({ resourceId, serviceId }) {
      const { storeId } = this;
      this.showLoadingAvailableTimesIndicator();
      try {
        await this.fetchAvailableBookingTimes({
          storeId,
          resourceId,
          serviceId
        });
      } catch ({ message }) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: message
        });
      }
      this.hideLoadingAvailableTimesIndicator();
    },
    showLoadingAvailableTimesIndicator() {
      this.isLoadingAvailableTimes = true;
    },
    hideLoadingAvailableTimesIndicator() {
      this.isLoadingAvailableTimes = false;
    },
    async saveQuickAddEvent() {
      this.showSavingQuickAddIndicator();
      const { quickAddForm, quickAddFormSelectedTime } = this;
      const [hour, minute] = quickAddFormSelectedTime.split(':');
      const { service } = quickAddForm;
      const _package = quickAddForm.package;
      const price = service.pricesForPackages[_package._id];

      const start = moment().set({ hour, minute, second: 0 });
      const end = moment()
        .set({ hour, minute, second: 0 })
        .add(service.baseDuration, 'minutes');

      const booking = {
        ...quickAddForm,
        start: start.format(),
        startDate: start.format('YYYY-MM-DD'),
        startTime: start.format('HH:mm'),
        end: end.format(),
        endDate: end.format('YYYY-MM-DD'),
        endTime: end.format('HH:mm'),
        price
      };

      try {
        await this.createBooking({ booking });
        this.hideQuickAddModal();
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Booking added.'
        });
      } catch ({ message }) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: message
        });
      } finally {
        this.hideSavingQuickAddIndicator();
      }
    },
    showSavingQuickAddIndicator() {
      this.isSavingQuickAdd = true;
    },
    hideSavingQuickAddIndicator() {
      this.isSavingQuickAdd = false;
    },
    async saveBreakEvent() {
      this.showSavingBreakIndicator();
      const {
        breakForm,
        breakFormSelectedDuration,
        breakFormSelectedTime
      } = this;
      const [hour, minute] = breakFormSelectedTime.split(':');
      let { start, end } = breakForm;

      start = moment(start)
        .set({ hour, minute, second: 0 })
        .format();
      end = moment(end)
        .set({ hour, minute, second: 0 })
        .add(breakFormSelectedDuration, 'minutes')
        .format();

      const breakEvent = {
        ...breakForm,
        start,
        end
      };

      try {
        await this.createEvent(breakEvent);
        this.hideBreakModal();
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'Break added.'
        });
      } catch ({ message }) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: message
        });
      } finally {
        this.hideSavingBreakIndicator();
      }
    },
    showSavingBreakIndicator() {
      this.isSavingBreak = true;
    },
    hideSavingBreakIndicator() {
      this.isSavingBreak = false;
    }
  },
  computed: {
    ...mapGetters({
      resources: 'resources/resourcesList',
      services: 'services/servicesList',
      packages: 'packages/packagesList',
      storeId: 'stores/storeId',
      availableBookingTimes: 'bookings/availableBookingTimes'
    }),
    resourceOptions() {
      return this.resources;
    },
    firstResourceOption() {
      const { resourceOptions } = this;
      if (!resourceOptions.length) return;
      return resourceOptions[0];
    },
    serviceOptions() {
      const { resource } = this.quickAddForm;

      if (!resource) return [];

      const resourceId = resource._id;

      return this.services.filter(
        service => service.resourcesEnabled[resourceId]
      );
    },
    packageOptions() {
      const { service } = this.quickAddForm;

      if (!service) return [];

      return this.packages.filter(
        _package => service.packagesEnabled[_package._id]
      );
    },
    availableBookingTimeOptions() {
      const today = moment().format('YYYY-MM-DD');
      const todayTimes = this.availableBookingTimes[today] || [];
      return todayTimes.map(time => ({ value: time, text: time }));
    },
    hasAvailableBookingTimes() {
      return this.availableBookingTimeOptions.length > 0;
    },
    firstAvailableBookingTime() {
      const { availableBookingTimeOptions } = this;
      if (!availableBookingTimeOptions.length) return;
      return availableBookingTimeOptions[0].value;
    },
    isQuickAddFormValid() {
      const { quickAddForm, quickAddFormSelectedTime } = this;
      const { resource, service, customer } = quickAddForm;
      const _package = quickAddForm.package;
      if (!resource) return false;
      if (!service) return false;
      if (!_package) return false;
      if (!quickAddFormSelectedTime) return false;
      if (!customer.name) return false;
      if (!customer.phoneNumber) return false;
      return true;
    },
    isBreakFormValid() {
      if (!this.breakForm.resourceId) return false;
      if (this.isLoadingAvailableTimes) return false;
      if (!this.breakFormSelectedTime) return false;
      return true;
    }
  },
  created() {
    this.fetchResources();
    this.fetchServices();
    this.fetchPackages();
  }
};
</script>
